import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

interface DataBlockCounterProps {
  value: number;
  onChange: (newValue: number) => void;
  disableDecrement?: boolean;
  disableIncrement?: boolean;
  min?: number;
  max?: number;
}

const DataBlockCounter: React.FC<DataBlockCounterProps> = ({
  value,
  onChange,
  disableDecrement = false,
  disableIncrement = false,
  min = 0,
  max,
}) => {
  const handleChange = (newVal: number) => {
    if (!isNaN(newVal)) {
      if (typeof max === 'number' && newVal > max) return;
      if (typeof min === 'number' && newVal < min) return;
      onChange(newVal);
    }
  };

  return (
    <Box className="data-block-wrapper">
      {disableDecrement ? null :
        <IconButton
          onClick={() => handleChange(Math.max((value || 0) - 1, min))}
          disabled={disableDecrement}
          size="small"
          className="data-block-button"
        >
          <Remove fontSize="small" />
        </IconButton>}

      <input
        type="number"
        className="data-block-input data-block-no-spinner"
        value={value ?? 0}
        min={min}
        max={max}
        disabled={disableIncrement}
        style={{padding:"7px"}}
        onChange={(e) => handleChange(parseInt(e.target.value, 10))}
      />
      {disableIncrement ? null :
        <IconButton
          onClick={() => handleChange((value || 0) + 1)}
          disabled={disableIncrement}
          size="small"
          className="data-block-button"
        >
          <Add fontSize="small" />
        </IconButton>}
    </Box>
  );
};

export default DataBlockCounter;
